/**
 * @file
 * Property card behavior.
 *
 * @description
 * Shows the investor CTA only when investor mode is enabled
 * in the session cookie.
 */

import { getInvestorMode } from '../../src/investor-mode.ts';

((Drupal, once) => {
  'use strict';

  /**
   * Returns whether investor mode is currently enabled.
   */
  function isInvestorModeEnabled(): boolean {
    return getInvestorMode() === true;
  }

  Drupal.behaviors.tpPropertyCard = {
    attach(context: Document | HTMLElement) {
      const ctas = once('tp-property-card-investor-cta', '[data-investor-mode-cta]', context);
      const isEnabled = isInvestorModeEnabled();

      if (ctas.length <= 0) return;

      ctas.forEach((element) => {
        const cta = element as HTMLElement;
        if (isEnabled) {
          cta.removeAttribute('hidden');
        } else {
          cta.setAttribute('hidden', '');
        }
      });
    },
  };
})(Drupal, once);
